import React, { useState } from 'react'
import logo from '../Assets/no_bg/logo.png'
import Cart from '../components/Cart'
import { Outlet } from 'react-router-dom'
import { ShoppingCart } from '@mui/icons-material'

const Navbar = ({ buttonAction, items, setItems }) => {
  const [ cartVisible, setCartVisible ] = useState(false)
  return (
    <div>
    <div className='flex bg-gray-100 justify-between p-2'>
      <div className='flex justify-center items-center space-x-2'>
        <div className='bg-blue-500 p-2 rounded-full'>
            <img src={logo} alt='logo' className=' w-[20px] h-[20px]'/>
        </div>
        <p className='font-bold'>Cynthia's Sneakers</p>
      </div>
        <div onClick={() => setCartVisible(!cartVisible)} className='flex cursor-pointer space-x-4 px-4'>
            <ShoppingCart/>
        </div>
        </div>
        <div>
        {
          cartVisible && <Cart 
          items={items}
           setItems={setItems}
            buttonAction={buttonAction}
             setCartVisible={setCartVisible}/>
        }
    </div>
    <Outlet/>
    </div>
  )
}
export default Navbar